/* eslint-disable no-nested-ternary */
import React, { useCallback } from "react";

import { Grid } from "@mui/material";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BsChevronRight } from "react-icons/bs";

import { Location } from "../../../../../../../models/location";
import useStyles from "./styles";

interface Props {
  origin: Location[];
  destination: Location[];
}

const SummaryLocation = (props: Props) => {
  const { origin, destination } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const renderAddress = useCallback((locations?: Location[]) => {
    if (locations && locations?.length > 0) {
      const location = locations[0];
      const number = location.number ? location.number : "";
      const address = location.addressLine1
        ? number
          ? ` ${location.addressLine1}`
          : location.addressLine1
        : "";
      const suburb = location.suburb ? (address ? `, ${location.suburb}` : location.suburb) : "";
      const concatened = number + address + suburb;
      const render = concatened || location.longAddress;

      return render ? (render.length > 35 ? `${render.substr(0, 35)}...` : render) : "";
    }

    return "";
  }, []);

  const renderComplementAddress = useCallback((locations?: Location[]) => {
    if (locations && locations?.length > 0) {
      const location = locations[0];
      const state = location.state ? location.state : "";
      const postalcode = location.postalcode
        ? state
          ? `, ${location.postalcode}`
          : location.postalcode
        : "";
      const country = location.country
        ? postalcode
          ? `, ${location.country}`
          : state
          ? `, ${location.country}`
          : location.country
        : "";

      return state + postalcode + country;
    }

    return "";
  }, []);

  const renderLocation = (label: string, location: Location[]) => {
    return (
      <Stack>
        <span className={classes.label}>{label}</span>
        <Stack className={classes.addressText}>
          {location && location.length > 0 && location[0].country ? (
            <>
              <span>{renderAddress(location)}</span>
              <span>{renderComplementAddress(location)}</span>
            </>
          ) : (
            <span className={classes.labelNotINformed}>{translate("notInformed")}</span>
          )}
        </Stack>
      </Stack>
    );
  };

  return (
    <div className={classes.locationContainer}>
      {
        <Grid alignItems="center" justifyContent="flex-start" spacing={4} container>
          <Grid item md={3} xl={2}>
            {renderLocation(translate("origin"), origin)}
          </Grid>
          <Grid item className={classes.icon}>
            <BsChevronRight className={classes.iconColor} size={18} />
          </Grid>
          <Grid item md={3} xl={2}>
            {renderLocation(translate("destination"), destination)}
          </Grid>
        </Grid>
      }
    </div>
  );
};

export default SummaryLocation;
